import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "geo-back-arrow-gray",
  "use": "geo-back-arrow-gray-usage",
  "viewBox": "0 0 38 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 37\" id=\"geo-back-arrow-gray\"><path d=\"M22.451 14.755h-9.144l1.894-1.263a.583.583 0 1 0-.645-.968l-3.5 2.33a.583.583 0 0 0 0 .969l3.5 2.33a.583.583 0 0 0 .646-.969l-1.895-1.26h9.144a3.5 3.5 0 1 1 0 6.99h-8.737a.583.583 0 0 0 0 1.165h8.737a4.66 4.66 0 1 0 0-9.32z\" fill=\"#cfd7df\" data-name=\"Group 9054\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol